<div class="wait-list-header" data-cy="wait-list-header">
  <div data-cy="wait-list-title">Appointment Wait List</div>
</div>

<div data-cy="wait-list-container">
<dx-list
  height="680"
  [dataSource]="listofApptsOnWaitList"
  [searchEnabled]="true"
  [searchExpr]="['Patient_FullName', 'Doctor_FullName', 'Patient_Comm', 'RefDoctor_FullName']"
  itemTemplate="listItem"
  data-cy="wait-list">

  <div *dxTemplate="let item of 'listItem'" data-cy="wait-list-item">
    <table class="tablecontainer" data-cy="wait-list-item-table">
      <tr data-cy="wait-list-item-row1">
        <td class="column1" data-cy="wait-list-item-date"> {{item.StartDate | date}} </td>
        <td class="column2" data-cy="wait-list-item-start-time"> {{item.StartDate | date:'shortTime'}} </td>
        <td class="column3" data-cy="wait-list-item-patient-name"><b>{{item.Patient_FullName}}</b></td>
        <td class="column4" data-cy="wait-list-item-doctor-name">{{item.Doctor_FullName}}</td>
<!--        <td class="column5"> <dx-button width="120" text="Open" (onClick)="onOpenClick(item)"></dx-button> </td>-->
      </tr>
      <tr data-cy="wait-list-item-row2">
        <td class="column1"> </td>
        <td class="column2" data-cy="wait-list-item-end-time"> {{item.EndDate | date:'shortTime'}} </td>
        <td class="column3" data-cy="wait-list-item-patient-contact"> Contact:{{item.Patient_Contact}}</td>
        <td class="column4" data-cy="wait-list-item-subject"> {{item.subject}}</td>
        <td class="column5"> <dx-button width="120" text="Reschedule" (onClick)="onReschedClick(item)" data-cy="wait-list-item-reschedule-button"></dx-button> </td>
      </tr>
      <tr data-cy="wait-list-item-row3">
        <td class="column1" data-cy="wait-list-item-requested-label">Requested:</td>
        <td class="column2" data-cy="wait-list-item-comms-label">Comms:</td>
        <td class="column3" data-cy="wait-list-item-comms">{{item.Patient_Comm}}</td>
        <td class="column4" data-cy="wait-list-item-description">
           <div style="word-wrap: break-word; white-space: pre-wrap;" data-cy="wait-list-item-description-text">
            {{ item.Description}}
           </div>
        </td>
        <td class="column5"> <dx-button width="120" text="Delete" (onClick)="onDeletClick(item)" data-cy="wait-list-item-delete-button"></dx-button> </td>
      </tr>

      <tr data-cy="wait-list-item-row4">
        <td class="column1" data-cy="wait-list-item-date-waitlisted"> {{item.DateWaitListed | date}} </td>
        <td class="column2" data-cy="wait-list-item-referred-by-label"> Referred By:</td>
        <td class="column3" data-cy="wait-list-item-referring-doctor">{{item.RefDoctor_FullName}}</td>
        <td class="column4"> </td>
      </tr>
    </table>


  </div>

  <dxo-search-editor-options
    placeholder="Type search value here..."
    label="  Search fields: Patient Name, Doctor Name, Referring Doctor Name, Comms."
    width="790"
    data-cy="wait-list-search-editor">
  </dxo-search-editor-options>

</dx-list>

</div>


<!--<div style="margin: 8px; float: right;">-->
<!--  <dx-button stylingMode="contained"  type="default" text="Close"></dx-button>-->
<!--</div>-->

